import SearchWordListContainer from './SearchWordListContainer';
export default SearchWordListContainer;
